import styled from 'styled-components';
import { FormControl, FormGroup } from '@mui/material';
import { Styling } from '../../../constants';

export const parametersContainerWidth = 400;

export const ControlLabel = styled.div`
  margin-right: ${Styling.DEFAULT_SPACING}px !important;
`;

export const Container = styled.div`
  display: flex;
`;

export const ParamsContainer = styled.div`
  margin-top: ${Styling.DEFAULT_SPACING}px;
  margin-left: ${Styling.DEFAULT_SPACING}px;
`;

export const FilterContainer = styled(FormControl)`
  width: 125px !important;
  margin-right: ${Styling.DEFAULT_SPACING}px !important;
`;

export const SelectedTeamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${Styling.DEFAULT_SPACING}px;
`;

export const FormContainer = styled(FormGroup)`
  align-self: flex-end;
  @media only screen and (min-width: ${Styling.SCREEN_XL}px) {
    align-self: inherit;
  }
`;
